// CampusDashboard.js - Re-exports the router component
import CampusDashboardRouter from "./CampusDashboardRouter";

export default CampusDashboardRouter;
